'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'coin-vertical';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'e3fd';
var svgPathData = 'M275.6 360c6.2-24.8 10.3-51.8 11.8-80l48 0c-1.5 29.1-5.6 56.1-11.7 80l-48 0zM228 464c12.2-15.6 23-34.5 31.9-56l47.3 0c-1.2 2.6-2.4 5.1-3.6 7.6-20.6 41.2-40.2 48.4-47.6 48.4l-28 0zM0 256C0 397.4 64.5 512 144 512l112 0c70.7 0 128-114.6 128-256S326.7 0 256 0L144 0C64.5 0 0 114.6 0 256zM263.1 112c-9.5-24.8-21.4-46.5-35.1-64l28 0c7.4 0 27 7.2 47.6 48.4 2.4 4.9 4.8 10.1 7 15.6l-47.5 0zm24.3 120c-1.3-25.2-4.7-49.4-9.8-72l48.1 0c5 21.9 8.5 46.1 9.8 72l-48 0zM144 448c-53 0-96-86-96-192s43-192 96-192 96 86 96 192-43 192-96 192zm64-192c0-79.5-28.7-144-64-144s-64 64.5-64 144 28.7 144 64 144 64-64.5 64-144zm-64 80c-5 0-9.4-11.4-12.4-29.2-2.3-13.8-3.6-31.5-3.6-50.8s1.4-37 3.6-50.8C134.6 187.4 139 176 144 176s9.4 11.4 12.4 29.2c2.3 13.8 3.6 31.5 3.6 50.8s-1.4 37-3.6 50.8C153.4 324.6 149 336 144 336z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCoinVertical = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;